import {callApi} from './http';

export function signOut(payload) {
  return callApi('post','sign/out', payload)
}

export function getUserInfo(payload) {
  return callApi('post','user/info', payload)
}

export function getMessageList(payload) {
  return callApi('post','user/contact-search', payload)
}

export function messageDelete(payload) {
  return callApi('post','user/contact-delete', payload)
}

export function getEmailList(payload) {
  return callApi('post','setting/contact-email-search', payload)
}

export function setEmailList(payload) {
  return callApi('post','setting/contact-email-update', payload)
}

export function signIn(payload) {
  return callApi('post','sign/in', payload)
}

export function signUp(payload) {
  return callApi('post','sign/up', payload)
}

export function getSignList(payload) {
  return callApi('post','sign/list', payload)
}

export function signEdit(payload) {
  return callApi('post','sign/edit', payload)
}

export function signDelete(payload) {
  return callApi('post','sign/delete', payload)
}

export function signEditPassword(payload) {
  return callApi('post','sign/edit-password', payload)
}
